export default __webpack_public_path__ + "static/media/weightlossregime@2x.f872bd63.jpg";